import { COLORS, pickThemeFontStyles } from '@/theme';
import { Table } from 'antd';
import styled from 'styled-components';

export const StyledTable = styled(Table)`
  overflow-x: auto;

  .ant-table-thead .ant-table-cell,
  .ant-table-column-has-sorters {
    color: ${COLORS.WHITE};
    background: ${COLORS.DARK_BLUE};
    ${pickThemeFontStyles('14', '20')};
    padding: 0.75rem 0.625rem;

    &::before {
      background-color: ${COLORS.LIGHTEST_GRAY} !important;
    }
  }

  th.ant-table-column-has-sorters,
  th.ant-table-column-sort {
    color: ${COLORS.WHITE};
    background-color: ${COLORS.YELLOW} !important;
    ${pickThemeFontStyles('14', '20')};
    padding: 0.75rem 0.625rem;

    &::before {
      background-color: ${COLORS.LIGHTEST_GRAY} !important;
    }

    .ant-table-column-title {
      color: ${COLORS.WHITE};
    }
  }

  .ant-table-cell {
    color: ${COLORS.DARKEST_GRAY};
    min-width: 10rem;
  }

  &.orders-table .ant-table-cell {
    min-width: 0;
  }

  .ant-table-bordered {
    background-color: transparent;
  }

  .ant-table-thead .ant-table-cell {
    &:first-of-type {
      border-start-start-radius: 0px !important;
    }

    &:last-of-type {
      border-start-end-radius: 0px !important;
    }
  }

  .ant-table-tbody .ant-table-placeholder {
    z-index: 999 !important;
  }

  .ant-table-thead > tr > th .ant-input,
  .ant-table-thead > tr > th .ant-select,
  .ant-table-thead > tr > th .ant-select-selector,
  .ant-table-thead > tr > th .ant-picker-input input {
    font-size: 0.75rem;
  }
` as typeof Table;
